import { AutoMap } from '@automapper/classes';

export class MPCAEntity {
    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    Name!: string;
    @AutoMap()
    ScolaMaterial!: string;
    @AutoMap()
    DegradationLevel!: number;
}
